module.exports = __webpack_public_path__ + "static/media/ic_upload_img.908271b3.svg";